// i18next-extract-mark-ns-start common
import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import { Link as LocalizedLink } from '../LocalizedLink';
import { I18nextContext, useTranslation } from 'gatsby-plugin-react-i18next';
import { useContext } from 'react';

const BlogLatest = ({ data, allButton }) => {
  const posts = data.nodes;
  const { t } = useTranslation();
  const context = useContext(I18nextContext);

  return (
    <div className="mx-auto max-w-7xl pb-10">
      <div className="mx-auto grid max-w-lg grid-cols-1 gap-8 border-gray-200 sm:pt-16 lg:mx-0 lg:max-w-none lg:grid-cols-3">
        {posts.map(post => (
          <article
            key={post.id}
            className="flex max-w-xl flex-col items-start justify-between bg-white p-8 rounded-2xl shadow-custom hover:scale-105 transition duration-500"
          >
            <div className="flex items-center gap-x-4 text-xs">
              <time dateTime={post.frontmatter.date} className="text-gray-500">
                {post.frontmatter.date}
              </time>
            </div>
            <div className="group relative">
              <h3 className="mt-3 text-lg font-semibold leading-6 text-gray-900 group-hover:text-gray-600">
                <a
                  href={'/' + context.language + '/blog' + post.frontmatter.uri}
                >
                  <span className="absolute inset-0" />
                  {post.frontmatter.title}
                </a>
              </h3>
              <p className="mt-5 line-clamp-3 text-sm leading-6 text-gray-600">
                {post.frontmatter.perex}
              </p>
            </div>
            <div className="relative mt-8 flex items-center gap-x-4">
              <GatsbyImage
                objectFit="contain"
                className="rounded-full bg-gray-50"
                style={{ width: '2.5rem', height: '2.5rem' }}
                image={
                  post.frontmatter.author.photo.childImageSharp.gatsbyImageData
                }
              />
              <div className="text-sm leading-6">
                <p className="font-semibold text-gray-900">
                  <span className="absolute inset-0" />
                  {post.frontmatter.author.name}
                </p>
                <p className="text-gray-600">{post.frontmatter.author.role}</p>
              </div>
            </div>
          </article>
        ))}
        {allButton ? (
          <LocalizedLink
            to="blog"
            className="rounded-3xl bg-adw-blue w-56 mt-5 mx-auto lg:mx-0 py-3 px-6 text-center text-sm lg:text-base
            font-medium text-white shadow-md sm:inline-block hover:bg-white hover:border-adw-blue hover:text-adw-blue"
          >
            {t('Zobraziť všetky blogy')}
          </LocalizedLink>
        ) : null}
      </div>
    </div>
  );
};

export default BlogLatest;
